export default __webpack_public_path__ + "static/media/partner-rsp.98c03481.jpg";